import React from 'react'
import logo from 'assets/images/npix-academy-dark.svg'

const MainLogo = () => {
	return (
		<div className='flex w-[170px] h-[52px]'>
			<img src={logo} alt='Npix Logo' />
		</div>
	)
}

export default MainLogo
